import { configureStore } from '@reduxjs/toolkit';
// import { persistCombineReducers } from 'reduxjs-toolkit-persist';
import {
	persistStore,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
  } from 'redux-persist'
import createWebStorage from 'redux-persist/es/storage/createWebStorage'
// import autoMergeLevel2 from 'reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel2';
import userReducer from './slices/userSlice';
import contentReducer from './slices/contentSlice';
import { createLogger } from 'redux-logger'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import persistCombineReducers from 'redux-persist/es/persistCombineReducers';

const logger = createLogger();

const storage = createWebStorage('local');

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2

};

const _persistedReducer = persistCombineReducers(
	persistConfig, 
	{
		userData: userReducer,
		contentData: contentReducer
	}
);

export const store = configureStore({
  reducer: _persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
	serializableCheck: {
	  ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
	},
  }).concat(logger),
});

export const persistor = persistStore(store);